
      import Receiving from './receiving.vue'
      import type { App, Plugin } from 'vue'

      export const ReceivingPlugin: Plugin = {
        install(app: App) {
          app.component('Receiving', Receiving)
        },
      }
      export { Receiving }
      